import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { MDText } from 'i18n-react';
import Tooltip from '@adsk/bim360-matrix-react-tooltip';
import Button from '@adsk/bim360-matrix-react-button';
import Ul from '@adsk/bim360-matrix-react-ul';
import MenuItem from '@adsk/bim360-matrix-react-menu-item';
import { useLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';
import objectValues from '@adsk/bim360-matrix-react-helpers/es/objectValues';
import { ENTITY_TYPES } from './helpers/consts';

import './_EntityPickerTypeButton.scss';

const EntityPickerTypeButton = ({
  targetEntityTypes,
  openPickerModal,
  children,
  onAddReferenceClick
}) => {
  const { T } = useLocale(({ locale }) => new MDText(require(`./i18n/${locale}.json`)));
  const [isMenuOpen, setMenuOpen] = useState(false);

  const openModal = entityType => {
    setMenuOpen(false);
    openPickerModal(entityType);
    if (onAddReferenceClick && typeof onAddReferenceClick === 'function') {
      onAddReferenceClick({ entityType });
    }
  };

  if (targetEntityTypes.length === 1) {
    const currentTargetEntityType = targetEntityTypes[0];

    return (
      <Button
        styleType={Button.StyleType.INLINE_LINK}
        onClick={() => {
          openModal(currentTargetEntityType);
        }}
      >
        {children}
      </Button>
    );
  }

  return (
    <Tooltip
      show={isMenuOpen}
      place={Tooltip.Places.BOTTOM}
      trigger={Tooltip.TriggerEvents.CLICK}
      onHide={() => setMenuOpen(false)}
      tooltipClassName="EntityPickerTypeButton__tooltip"
      content={
        <Ul className="EntityPickerTypeButton__menu">
          {targetEntityTypes.map(type => (
            <MenuItem key={type} eventKey={type} onClick={() => openModal(type)}>
              {T.translate(`${type}_PLURAL`)}
            </MenuItem>
          ))}
        </Ul>
      }
    >
      <Button
        styleType={Button.StyleType.INLINE_LINK}
        onClick={() => {
          setMenuOpen(true);
        }}
      >
        {children}
      </Button>
    </Tooltip>
  );
};

EntityPickerTypeButton.propTypes = {
  /**
   * The target entity types we want to allow linking to.
   */
  targetEntityTypes: PropTypes.arrayOf(PropTypes.oneOf(objectValues(ENTITY_TYPES))).isRequired,
  /**
   * Handler to open entity selection modal.
   */
  openPickerModal: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  /**
   * Callback fired when user opens picker modal with a reference type.
   * Handler of shape: ({ entityType }) => *
   */
  onAddReferenceClick: PropTypes.func
};

export default EntityPickerTypeButton;
